import { type FC, memo } from 'react';

import { css } from '@emotion/css';

import { Icon } from 'components/icon/Icon';
import { Icons } from 'constants/icons';

import { CONTEXT25_COLORS } from '../constants/context25-campaign';

const iconWrapperStyle = css`
  position: relative;
  width: 26.31px;
  height: 26.31px;
  flex-shrink: 0;

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 68px;
    height: 68px;
  }
`;

export const Context25SparkleIcon: FC = memo(() => {
  return (
    <div className={iconWrapperStyle} data-testid="context25-sparkle-icon">
      <Icon name={Icons.SparkleStar} width="68px" height="68px" fill={CONTEXT25_COLORS.textAndIcons} />
    </div>
  );
});

Context25SparkleIcon.displayName = 'Context25SparkleIcon';
